import * as React from 'react';
import ReportWidget from './report-widget';
import { ReportWidget as ReportWidgetApi } from "../../misc/api/apiTypes";
import { ErrorBoundary } from "../../errors/ErrorBoundary";

interface ReportWidgetsProps {
    widgets: ReportWidgetApi[];
}

export const ReportWidgets = ({ widgets }: ReportWidgetsProps) => {
    const widgetComponents = widgets.map(item => <ReportWidget key={item.Id} name={item.Name} server={item.Server} path={item.Path} session={item.Session} parameters={item.Parameters} />)

    return (
        <ErrorBoundary>
            {widgetComponents}
        </ErrorBoundary>
    );
}
